import React from "react";
import FontAwesome from "react-fontawesome";
import AdminTitle from "../../components/AdminTitle";
import Api from "../../Api";
import moment from "moment";
import Button from "../../components/Button";
import "./AdminEmails.less";

export default class AdminEmails extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onEmailClick = this.onEmailClick.bind(this);

    this.state = {
      emails: null,
      nextRequest: null,
      error: null
    };
  }

  componentDidMount() {
    this.searchEmails(false);
  }

  searchEmails(more) {
    let request = {};
    let loadingMore = false;
    if (more && this.state.nextRequest) {
      request = this.state.nextRequest;
      loadingMore = true;
    }

    Api.searchEmails(request).then(
      (response) => {
        let emails = this.state.emails ? this.state.emails : [];
        emails = loadingMore ? emails.concat(response.emails) : response.emails;

        this.setState({
          emails: emails,
          nextRequest: response.next
        });
      },
      (error) => {
        this.setState({error});
      }
    );
  }

  onChange(event) {
    let payload = {};
    payload[event.target.name] = event.target.value;
    this.setState(payload)
  }

  onEmailClick(token) {
    window.open(`/api/email/view/${token}/html`, '_blank').focus();
  }

  render() {
    if (this.state.error) {
      console.error(this.state.error.message);
      return (<div className="error">Error: {this.state.error.message}</div>);
    }

    let emailList;
    let header;
    if (!this.state.emails) {
      emailList = <FontAwesome name="refresh" spin/>;
    } else {
      header = (
        <div key="header" className="email-list-entry">
          <span className="to">To</span>
          <span className="template">Template</span>
          <span className="send-at">Send At</span>
          <span className="sent-at">Sent At</span>
          <span className="bounced-at">Bounced At</span>
          <span className="delivered-at">Delivered At</span>
          <span className="first-opened-at">First Opened At</span>
          <span className="last-opened-at">Last Opened At</span>
          <span className="open-count">Open Count</span>
        </div>
      );
      emailList = this.state.emails.map((email) => {
        let token = email.token;
        let name = email.to_name || '';
        let emailAddress = email.to_email_address || '';
        let template = email.template;
        let sendAt = email.send_at ? moment(email.send_at).format('MM/DD') : '-';
        let sentAt = email.sent_at ? moment(email.sent_at).format('MM/DD') : '-';
        let bouncedAt = email.bounced_at ? moment(email.bounced_at).format('MM/DD') : '-';
        let deliveredAt = email.delivered_at ? moment(email.delivered_at).format('MM/DD') : '-';
        let firstOpenedAt = email.first_opened_at ? moment(email.first_opened_at).format('MM/DD') : '-';
        let lastOpenedAt = email.last_opened_at ? moment(email.last_opened_at).format('MM/DD') : '-';
        let openCount = email.open_count;

        return (
          <div key={token} onClick={this.onEmailClick.bind(this, token)} className="email-list-entry link">
            <span className="to">{name} - {emailAddress}</span>
            <span className="template">{template}</span>
            <span className="send-at">{sendAt}</span>
            <span className="sent-at">{sentAt}</span>
            <span className="bounced-at">{bouncedAt}</span>
            <span className="delivered-at">{deliveredAt}</span>
            <span className="first-opened-at">{firstOpenedAt}</span>
            <span className="last-opened-at">{lastOpenedAt}</span>
            <span className="open-count">{openCount}</span>
          </div>
        );
      });
    }

    return (
      <div className="email-list">
        <AdminTitle title="Outgoing Emails"/>
        {header}
        {emailList}
        <Button key={'load-more-button'} onClick={this.searchEmails.bind(this, true)}>
          Load More
        </Button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminEmails.js
 **/